module.exports = __webpack_public_path__ + "media/images/download-ios-btn-68086e5934bb2e3ec965cb0874054f1b.png";